import * as React from 'react';
import { connect } from 'react-redux';

import BaseCampaignPage from 'modules/campaigns/pages/BaseCampaignPage';

import ReportingSideNavigation from 'modules/reporting/components/side-navigation/ReportingSideNavigation';

import { fetchMetaInfo, resetMetaInfo } from 'modules/reporting/reducers/meta-info';

import { applyTranslations } from 'utils/language';
import { getActions, getReporting, prepareNavigationItems } from '../../utils/reporting-navigation';

import type { Campaign, Params } from 'types';
import type { ReportingMetaInfo } from 'modules/reporting/types/ReportingMetaInfo.type';

import './base-reporting-page.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

type OwnProps = {
  params: Params,
  headline: string,
  children?: React.ReactNode
};

type StateProps = {
  campaign: Campaign,
  metaInfo: ReportingMetaInfo,
  isV2Campaign: boolean
};

type DispatchProps = {
  dispatchFetchMetaInfo: (a: number) => void,
  dispatchResetMetaInfo: () => void
};

type Props = StateProps & OwnProps & DispatchProps;

const BaseReportingPage = (
  {
    headline,
    campaign,
    params,
    children,
    metaInfo,
    isV2Campaign,
    dispatchFetchMetaInfo,
    dispatchResetMetaInfo
  }: Props
): JSX.Element => {
  React.useEffect(() => {
    dispatchFetchMetaInfo(Number(params.id));

    return dispatchResetMetaInfo;
  }, [params.id]);

  const reporting = getReporting(metaInfo);
  const actions = getActions(metaInfo);

  return (
    <BaseCampaignPage
      params={params}
      documentTitle={headline}
      pageType="report"
    >
      <section className="base-reporting-page">
        {
          isV2Campaign && (
            <ReportingSideNavigation
              campaignId={campaign.id}
              reporting={prepareNavigationItems(campaign, reporting)}
              actions={prepareNavigationItems(campaign, actions)}
            />
          )
        }
        <section className="base-reporting-page__content">
          <div className="base-reporting-page__content">
            {children}
          </div>
        </section>
      </section>
    </BaseCampaignPage>
  );
};

const mapStateToProps = ({ campaignBrief, reportingMetaInfo, campaignDeliverables }): StateProps => ({
  campaign: campaignBrief.brief,
  metaInfo: reportingMetaInfo.metaInfo,
  isV2Campaign: campaignDeliverables.isV2Campaign
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchMetaInfo: (campaignId: number) => dispatch(fetchMetaInfo(campaignId)),
  dispatchResetMetaInfo: () => dispatch(resetMetaInfo())
});

export default connect(mapStateToProps, mapDispatchToProps)(BaseReportingPage);
